import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  path: string;
  type?: string;
}

const SITE_NAME = 'Five AI';
const BASE_URL = 'https://app.fiveai.ai';

/**
 * Lightweight SEO hook — sets document title and meta tags per page.
 * No external dependencies (no react-helmet needed).
 */
export function useSEO({ title, description, path, type = 'website' }: SEOProps) {
  useEffect(() => {
    // Title
    document.title = `${title} | ${SITE_NAME}`;

    // Meta description
    setMeta('description', description);

    // Canonical
    setLink('canonical', `${BASE_URL}${path}`);

    // Open Graph
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', `${BASE_URL}${path}`, 'property');
    setMeta('og:type', type, 'property');

    // Twitter
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
  }, [title, description, path, type]);
}

function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}
